import { usePageHeader } from "@/components/layouts/lib/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/App";
import { AppearanceTab } from "./settings/appearance/AppearanceTab";
import { BackupsTab } from "./settings/backups/BackupsTab";
import { CatalogTab } from "./settings/catalog/CatalogTab";
import { SettingsAdminIntro } from "./settings/components/SettingsAdminIntro";
import { MaintenanceTab } from "./settings/maintenance/MaintenanceTab";
import { NotificationsTab } from "./settings/notifications/NotificationsTab";
import { SETTINGS_PAGE_GUIDE } from "./settings/settingsPage.constants";
import { SystemSettingsTab } from "./settings/system-settings/components/SystemSettingsTab";

export default function SettingsPage() {
  const { user } = useAuth();
  usePageHeader({
    title: "Paramètres",
    helpTopic: "parametres",
    guide: {
      steps: SETTINGS_PAGE_GUIDE,
    },
  });

  // dev's only allowed surface here is Sauvegardes (C2) — every other tab
  // reads settings the backend keeps admin+-only, so showing them would just
  // produce a page full of failed fetches for this role.
  if (user?.role === "dev") {
    return (
      <div className="space-y-5">
        <SettingsAdminIntro />
        <BackupsTab />
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <SettingsAdminIntro />

      <Tabs defaultValue="financial">
        <TabsList>
          <TabsTrigger value="financial">Finances</TabsTrigger>
          <TabsTrigger value="security">Sécurité</TabsTrigger>
          <TabsTrigger value="mail">E-mails</TabsTrigger>
          <TabsTrigger value="rewards">Récompenses</TabsTrigger>
          <TabsTrigger value="catalog">Catalogue commissions</TabsTrigger>
          <TabsTrigger value="notifications">Notifications</TabsTrigger>
          <TabsTrigger value="appearance">Apparence</TabsTrigger>
          <TabsTrigger value="backups">Sauvegardes</TabsTrigger>
          <TabsTrigger value="maintenance">Maintenance</TabsTrigger>
        </TabsList>

        <TabsContent value="financial">
          <SystemSettingsTab categoryId="financial" />
        </TabsContent>
        <TabsContent value="security">
          <SystemSettingsTab categoryId="security" />
        </TabsContent>
        <TabsContent value="mail">
          <SystemSettingsTab categoryId="mail" />
        </TabsContent>
        <TabsContent value="rewards">
          <SystemSettingsTab categoryId="rewards" />
        </TabsContent>
        <TabsContent value="catalog">
          <CatalogTab />
        </TabsContent>
        <TabsContent value="notifications">
          <NotificationsTab />
        </TabsContent>
        <TabsContent value="appearance">
          <AppearanceTab />
        </TabsContent>
        <TabsContent value="backups">
          <BackupsTab />
        </TabsContent>
        <TabsContent value="maintenance">
          <MaintenanceTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
